import styled from 'styled-components';

export const Card = styled.div`
    margin-top: 100px;
    background: white;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    padding: 50px 40px;
    max-width: 500px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;

    button {
        margin-top: 30px;
        padding: 12px 40px;
        font-size: 1rem;
        border-radius: 4px;
        transition: all 0.3s ease;

        &:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 8px rgba(3, 116, 230, 0.3);
        }
    }
`;

export const CardTitle = styled.h4`
    color: #333;
    font-size: 1.75rem;
    font-weight: 600;
    margin: 0 0 16px 0;
`;

export const CardDescription = styled.p`
    white-space: pre-wrap;
    color: #666;
    font-size: 1rem;
    line-height: 1.6;
    margin: 0;
`;
